module.exports = __webpack_public_path__ + "static/media/tti_easiest_way_to_move.b810a0c6.png";